/*
 * Botón "Exportar a Excel" de cada sección. Pide GET /attendance/exportar/ (permiso
 * generate_report_attendance; quien no lo tiene no ve el botón, ver SectionHeader) con los mismos filtros
 * de la pantalla + `seccion` (y `agrupar` en Horas) y guarda el archivo. Mientras genera queda deshabilitado
 * ("Generando…"); un rango de más de 93 días se avisa sin llamar al servidor; los errores salen en un
 * párrafo role="alert" con el mensaje real del servidor. El token viaja solo en el header (axios).
 */
import React, {useEffect, useRef, useState} from "react";
import {downloadAttendanceExcel} from "../../../../redux/attendance";
import {downloadErrorMessage, exportFileName, saveBlob} from "../utils/download";
import {longRangeMessage} from "../utils/period";

const ExportButton = ({token, params, range}) => {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [done, setDone] = useState('');
    const mounted = useRef(true);
    useEffect(() => () => {
        mounted.current = false;
    }, []);

    // Al cambiar de sección o de filtros se borran los avisos del intento anterior.
    const paramsKey = JSON.stringify(params);
    useEffect(() => {
        setError('');
        setDone('');
    }, [paramsKey]);

    async function exportar() {
        if (busy) return;
        setError('');
        setDone('');
        const tooLong = longRangeMessage(range, 'La exportación');
        if (tooLong) {
            setError(tooLong);
            return;
        }
        setBusy(true);
        try {
            const blob = await downloadAttendanceExcel(token, params);
            saveBlob(blob, exportFileName(params.seccion, range));
            if (mounted.current) setDone('Excel descargado');
        } catch (failure) {
            const message = await downloadErrorMessage(failure);
            if (mounted.current) setError(message);
        } finally {
            if (mounted.current) setBusy(false);
        }
    }

    return (
        <>
            <button type="button" className="btn btn-outline-primary btn-sm mc-export" onClick={exportar}
                    disabled={busy} aria-busy={busy}>
                <i className="bx bx-download" aria-hidden="true"/>
                {busy ? 'Generando…' : 'Exportar a Excel'}
            </button>
            {error && <p className="mc-export__error" role="alert">{error}</p>}
            <p className="mc-sr-only" role="status">{done}</p>
        </>
    );
};

export default ExportButton;
